import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'ldw-document-not-found-dialog',
    templateUrl: './document-not-found-dialog.component.html',
    styleUrls: ['./document-not-found-dialog.component.css'],
    standalone: false
})
export class DocumentNotFoundDialogComponent {
  dialogRef = inject<MatDialogRef<DocumentNotFoundDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  title!: string;
  message!: string;

}
